<template>
  <div class="nav-arrows" v-if="totalScenes > 1">
    <button class="nav-arrow nav-prev" @click="$emit('prev')" :title="'Previous scene'">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
        <path d="M15 18l-6-6 6-6"/>
      </svg>
    </button>
    <button class="nav-arrow nav-next" @click="$emit('next')" :title="'Next scene'">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
        <path d="M9 18l6-6-6-6"/>
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  totalScenes: number
}>()

defineEmits<{
  prev: []
  next: []
}>()
</script>

<style scoped>
.nav-arrows {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 12px;
  pointer-events: none;
  z-index: 11;
}

.nav-arrow {
  pointer-events: auto;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.nav-arrow:hover {
  background: rgba(0, 0, 0, 0.75);
  color: white;
  transform: scale(1.1);
}

@media (max-width: 640px) {
  .nav-arrow {
    width: 32px;
    height: 32px;
  }
  .nav-arrow svg {
    width: 18px;
    height: 18px;
  }
}
</style>
